import { Container, Row, Col } from 'react-grid-system';
import imageSearch from '../../Images/Home/search.svg';
import imageConnection from '../../Images/Home/connection.svg';
import imageHire from '../../Images/Home/hire.svg';
import  '../../Styles/Sass/HowItWorks.scss';

function App() {
  return (
    <section className='howItWorks'>
      <h2 className='howItWorks__title'>HOW IT WORKS</h2>
      <Container fluid={true} className='howItWorks__list'>
        <Row justify={'around'}>
          <Col md={4} className='howCard'>
            <img className='howCard__image' src={imageSearch} alt="" />
            <h3 className='howCard__title'>1. Browse Cleaners</h3>
            <p className='howCard__description'>Looking for a cleaning service? Search resumes or post your job and let candidates come to you</p>
          </Col>
          <Col md={4} className='howCard'>
            <img className='howCard__image' src={imageConnection} alt="" />
            <h3 className='howCard__title'>2. Connect With Candidates</h3>
            <p className='howCard__description'>Hand select jobs or candidates by connecting with them through your secure inbox</p>
          </Col>
          <Col md={4} className='howCard'>
            <img className='howCard__image' src={imageHire} alt="" />
            <h3 className='howCard__title'>3. Hire Your Best Match</h3>
            <p className='howCard__description'>Whether you’re looking for a job or posting a job, select your best match by reviewing profiles, reading endorsements, and accessing peer reviews.</p>
          </Col>
        </Row>
      </Container>
      <button className='blueButton howItWorks__button'>Begin Search</button>
    </section>
  );
}

export default App;
